import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const caseNumberAction = (value) => ({
  type: actions.CASE_NUMBER,
  payload: {
    description: value,
  },
})

export const confirmCaseNumberAction = (value) => ({
  type: actions.CONFIRM_CASE_NUMBER,
  payload: {
    description: value,
  },
})

export const amountOwingAction = (value) => ({
  type: actions.AMOUNT_OWING,
  payload: {
    description: value,
  },
})

export const paymentAmountAction = (value) => ({
  type: actions.PAYMENT_AMOUNT,
  payload: {
    description: value,
  },
})

export const paymentAmountFullAction = (value) => ({
  type: actions.PAYMENT_AMOUNT_FULL,
  payload: {
    description: value,
  },
})

export const minPaymentAmountAction = (value) => ({
  type: actions.MIN_PAYMENT_AMOUNT,
  payload: {
    description: value,
  },
})

export const caseSotIdAction = (value) => ({
  type: actions.CASE_SOT_ID,
  payload: {
    description: value,
  },
})

export const receiptDetailAction = (value) => ({
  type: actions.RECEIPT_DETAIL,
  payload: {
    description: value,
  },
})

export const caseTypeAction = (value) => ({
  type: actions.CASE_TYPE,
  payload: {
    description: value,
  },
})

export const emailAddressAction = (value) => ({
  type: actions.EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const confirmEmailAddressAction = (value) => ({
  type: actions.CONFIRM_EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const editCaseNumberAction = (value) => ({
  type: actions.EDIT_CASE_NUMBER,
  payload: {
    caseNumber: value,
  },
})

export const addCaseAction = (data) => ({
  type: actions.ADD_CASE,
  payload: {
    caseNumber: data.caseNumber,
    amountOwing: data.amountOwing,
    paymentAmount: data.paymentAmount,
    paymentAmountFull: data.paymentAmountFull,
    minPaymentAmount: data.minPaymentAmount,
    caseSotId: data.caseSotId,
    receiptDetail: data.receiptDetail,
    caseType: data.caseType,
  },
})

export const editCaseAction = (data) => ({
  type: actions.EDIT_CASE,
  payload: {
    caseNumber: data.caseNumber,
    amountOwing: data.amountOwing,
    paymentAmount: data.paymentAmount,
    paymentAmountFull: data.paymentAmountFull,
    minPaymentAmount: data.minPaymentAmount,
    caseSotId: data.caseSotId,
    receiptDetail: data.receiptDetail,
    caseType: data.caseType,
  },
})

export const deleteCaseAction = (caseNumber) => ({
  type: actions.DELETE_CASE,
  payload: {
    caseNumber: caseNumber,
  },
})

export const clearCaseAction = () => ({
  type: actions.CLEAR_CASE_INFO,
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})
